import { Volume2, VolumeX } from "lucide-react";
import { TOKENKU_VOICE, TTS_LANGS, ttsSupported } from "./useTTS";

export const TtsControls = ({ tts, lang, onLang, locked }) => {
  return (
    <div className="flex items-center gap-2" data-testid="tts-controls">
      <div className={`flex rounded-full border border-white/15 p-1 ${locked ? "opacity-40" : ""}`} role="group" aria-label="Script language" title={locked ? "Save or cancel your edit first" : "Script & voice language"}>
        {TTS_LANGS.map((l) => (
          <button
            key={l.code}
            disabled={locked}
            onClick={() => onLang(l.code)}
            title={l.name}
            data-testid={`tts-lang-${l.code}`}
            className={`rounded-full px-3 py-1.5 font-mono-d text-[11px] tracking-[0.14em] transition-colors ${
              lang === l.code ? "bg-zinc-100 text-black" : "text-zinc-300 hover:text-white"
            }`}
          >
            {l.label}
          </button>
        ))}
      </div>
      {ttsSupported && (
      <>
      <button
        onClick={() => tts.setEnabled((v) => !v)}
        aria-label={tts.enabled ? "Turn voice off" : "Turn voice on"}
        title={`${TOKENKU_VOICE.name} — ${tts.enabled ? "on" : "off"}`}
        data-testid="tts-toggle-button"
        className={`grid h-12 w-12 place-items-center rounded-full border transition-colors duration-300 ${
          tts.enabled ? "border-dash bg-dash/15 text-dash" : "border-white/15 text-zinc-400 hover:border-white/40"
        }`}
      >
        {tts.enabled ? <Volume2 size={18} /> : <VolumeX size={18} />}
      </button>
      </>
      )}
    </div>
  );
};

export const TtsStatus = ({ tts }) => {
  if (!ttsSupported) {
    return (
      <p className="mt-3 text-xs text-zinc-500" data-testid="tts-unsupported-note">
        Voice read-aloud isn't supported in this browser — try Chrome, Edge or Safari.
      </p>
    );
  }
  return (
    <div className="mt-3 flex flex-wrap items-center gap-3" data-testid="tts-status">
      <span className="inline-flex items-center gap-2 rounded-full border border-white/10 px-3 py-1 font-mono-d text-[11px] text-zinc-400">
        <span className={`h-1.5 w-1.5 rounded-full ${tts.enabled && tts.line >= 0 ? "animate-pulse bg-dash" : "bg-zinc-600"}`} />
        {TOKENKU_VOICE.name} · {tts.voice?.name || "system default"} · pitch {TOKENKU_VOICE.pitch} · rate {TOKENKU_VOICE.rate}
        <span className="text-orange-200">· expressive</span>
      </span>
      {tts.enabled && tts.blocked && (
        <button onClick={tts.unlock} data-testid="tts-unlock-button" className="rounded-full bg-dash px-3 py-1 text-xs font-semibold text-black transition-colors hover:bg-[#ff8a33]">
          Browser blocked autoplay — click to start voice
        </button>
      )}
    </div>
  );
};
